<script lang="ts">
export default {
    name: "HistoryVideoPop",
};
</script>

<script setup lang="ts">
import { onMounted } from "vue"
import { store } from '@/store'
import { getMediaList } from "@/api/eventApi/index"
import { getWayLineList } from "@/api/eventApi/index"

const props = defineProps({
    isHistory: {
        type: Boolean,
        default: () => {
            return false;
        },
    },
});

const queryParams = reactive({
    times: [],
    waylineId: "",
    fileType: "VIDEO",
    deviceSn: "",
    startTime: "",
    endTime: "",
    page: 1,
    size: 999,
    subFileType:"1,2,3"
})

const wayLineList = ref()
const videoList = ref()
const emits = defineEmits(["update:isHistory"]);

const page = ref({
    page: 1,
    size: 999
});
const searchJobValue: any = ref({});
const organizationData: any = computed(() => store.informationListStore.informationStore().organizationData)

async function PrepareJobsAPageList() {
    searchJobValue.value.deviceSn = store.informationListStore.informationStore().airNumberValue
    searchJobValue.value.orgId = organizationData.value.provinceCode
    const params = { ...page.value, ...searchJobValue.value } as any;
    const result = await getWayLineList(params);
    wayLineList.value = result.list;
}

const searchBtn = () => {
    console.log(queryParams.times)
    PrepareJobsAPageList()
}

function dateList() {
    let date = new Date();
    let frontDate = new Date()
    let year = date.getFullYear();
    frontDate.setDate(frontDate.getDate() - 7)//前7天减7，前N天减N
    let dateArr1: any = [frontDate.getMonth() + 1, frontDate.getDate()];
    let dateArr2: any = [date.getMonth() + 1, date.getDate()];
    //开始格式是M,经过以下循环变为MM
    for (let i = 0; i < dateArr1.length; i++) {
        if (dateArr1[i] >= 1 && dateArr1[i] <= 9) {
            dateArr1[i] = "0" + dateArr1[i];
        }
    }
    for (let i = 0; i < dateArr2.length; i++) {
        if (dateArr2[i] >= 1 && dateArr2[i] <= 9) {
            dateArr2[i] = "0" + dateArr2[i];
        }
    }
    let strDate1:any = year + "-" + dateArr1[0] + "-" + dateArr1[1]
    let strDate2:any = year + "-" + dateArr2[0] + "-" + dateArr2[1]
    queryParams.times = [strDate1, strDate2]  //[2023-08-31,2023-09-07]
}

const MediaList = () => {
    if (queryParams.times.length) {
        queryParams.startTime = queryParams.times[0]
        queryParams.endTime = queryParams.times[1]
    }
    getMediaList(queryParams).then((res: any) => {
        videoList.value = res.list
    })
}

function formatTimestamp(timestamp: any) {
    if (!timestamp) return '';
    const date = new Date(timestamp);
    return date.toLocaleString(); // 根据本地时间格式显示
}

const videoUrl = ref()
const videoBtn = (list: any) => {
    videoUrl.value = list.url
}

const close = () =>{
    emits("update:isHistory", false);
}

watch(() => props.isHistory, async(newVal: any, oldVal) => {
    if (newVal) {
        queryParams.deviceSn = store.informationListStore.informationStore().uavObj.childSn
        await dateList()
        await PrepareJobsAPageList()
        await MediaList()
    }
}, {
    deep: true
})

</script>

<template>
    <div class="HistoryVideoPop-box" v-if="isHistory">
        <div class="title-box">
            <p>航点视频</p>
        </div>
        <p class="close" @click="close">
            <img src="@/assets/icons/video-close.png" alt="">
        </p>
        <div class="query">
            <el-form ref="queryFormRef" :model="queryParams" :inline="true">
                <el-form-item label="">
                    <el-date-picker v-model="queryParams.times" type="daterange" range-separator="至"
                        value-format="YYYY-MM-DD" start-placeholder="开始时间" end-placeholder="结束时间" />
                </el-form-item>
                <el-form-item label="航线名称">
                    <el-select v-model="queryParams.waylineId" placeholder="请选择航线">
                        <el-option v-for="item in wayLineList" :key="item.wayline_id" :label="item.name"
                            :value="item.wayline_id" />
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="searchBtn">搜索</el-button>
                </el-form-item>
            </el-form>
        </div>
        <div class="video-list-box">
            <div class="video-list" v-for="(item, index) in videoList" @click="videoBtn(item)">
                <p>
                    <img :src="item?.previewObjectUrl" alt="">
                </p>
                <p>{{ item?.fileName }}</p>
                <p>{{ formatTimestamp(item?.createTime) }}</p>
            </div>
        </div>
    </div>

    <div class="preview-video" v-if="videoUrl">
        <div class="preview-video-close" @click="() => { videoUrl = '' }">
            关闭
        </div>
        <video :src="videoUrl" controls :autoplay="true"></video>
    </div>
</template>

<style lang="scss" scoped>
.HistoryVideoPop-box {
    position: absolute;
    left: -920px;
    top: 150px;
    width: 1003px;
    height: 641px;
    border-radius: 8px;
    opacity: 1;
    background: rgba(1, 33, 50, 0.85);
    .close{
        width: 24px;
        height: 24px;
        position: absolute;
        right: -10px;
        top: -10px;
        cursor: pointer;
        img{
            width: 100%;
            height: 100%;
        }
    }
    .title-box {
        width: 19.5vw;
        height: 2.5vh;
        background: url("@/assets/icons/title-bg.png") no-repeat center;
        background-size: cover;
        display: flex;
        margin: 23px;

        p {
            font-family: YouSheBiaoTiHei;
            font-size: 1.125rem;
            font-weight: normal;
            color: #fff;
            margin: 0 0 0 1.5vw;
            line-height: 2.1vh;
        }
    }

    .query {
        margin-left: 23px;

        :deep(.el-range-editor.el-input__wrapper) {
            width: 220px;
            background: #000619;
            margin-left: 8px;

            .el-range-separator {
                color: #0BE8F6;
            }
        }

        :deep(.el-form-item__label) {
            font-size: 12px;
            font-weight: normal;
            color: #FFFFFF;
        }

        :deep(.el-select__wrapper) {
            width: 220px;
            height: 24px;
            background: #000619;
        }
    }

    .video-list-box {
        height: 480px;
        overflow-y: auto;
        display: flex;
        flex-wrap: wrap;

        .video-list {
            width: 200px;
            height: 160px;
            margin-left: 30px;
            cursor: pointer;
            p:nth-child(1) {
                width: 200px;
                height: 105px;
                border-radius: 3px;

                img {
                    width: 100%;
                    height: 100%;
                    border-radius: 3px;
                }
            }

            p:nth-child(2) {
                font-family: Inter;
                font-size: 12px;
                font-weight: normal;
                color: #0BE8F6;
            }

            p:nth-child(3) {
                font-family: Inter;
                font-size: 12px;
                font-weight: normal;
                color: #FFFFFF;
            }

            p {
                margin-top: 7px;
            }
        }
    }
}

.preview-video {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background-color: rgba(0, 0, 0, 0.45);
    display: flex;
    align-items: center;
    justify-content: center;
    align-content: center;
    overflow: hidden;
    z-index: 9999;
    flex-wrap: wrap;

    .preview-video-close {
        width: 50%;
        text-align: right;
        cursor: pointer;
        cursor: pointer;
        font-size: 18px;
        color: #fff;
    }

    video {
        width: 50.1%;
    }
}
</style>